/**
 * @typedef {Object} EgdJackpotMeter
 * @property {string} name - Game name (flattened from `game.gameName`)
 * @property {number} amount
 * @property {string} last_update_date
 * @property {string} last_update_time
 * @property {string} image
 * @property {string} last_hit_date
 * @property {string} last_hit_time
 * @property {string} location
 */

/**
 * Maps a Payload `egd-jackpot-meters` document to the legacy ERS shape
 * consumed by gameListUtils.
 *
 * @param {Record<string, unknown>} doc
 * @returns {EgdJackpotMeter}
 */
export function mapEgdJackpot(doc) {
  const safeDoc =
    doc && typeof doc === "object" && !Array.isArray(doc) ? doc : {};

  const game =
    safeDoc.game && typeof safeDoc.game === "object" && !Array.isArray(safeDoc.game)
      ? safeDoc.game
      : null;
  const name =
    game && typeof game.gameName === "string" ? game.gameName : "";

  return {
    name,
    amount: typeof safeDoc.amount === "number" ? safeDoc.amount : 0,
    last_update_date:
      typeof safeDoc.lastUpdatedAt === "string" ? safeDoc.lastUpdatedAt : "",
    last_update_time:
      typeof safeDoc.lastUpdateTime === "string" ? safeDoc.lastUpdateTime : "",
    image: "",
    last_hit_date: typeof safeDoc.lastHitAt === "string" ? safeDoc.lastHitAt : "",
    last_hit_time:
      typeof safeDoc.lastHitTime === "string" ? safeDoc.lastHitTime : "",
    location: typeof safeDoc.location === "string" ? safeDoc.location : "",
  };
}

/**
 * @param {{ docs?: unknown[] }} payloadResponse
 * @returns {EgdJackpotMeter[]}
 */
export function mapEgdJackpotsResponse(payloadResponse) {
  const docs = Array.isArray(payloadResponse?.docs) ? payloadResponse.docs : [];
  return docs.map((doc) => mapEgdJackpot(doc));
}
